import { ApiRequest } from "src/helpers";
import { API_END_POINTS } from "src/constants";

export function getBenchmarks() {
  return ApiRequest.fetchAdmin({
    method: "get",
    url: `${API_END_POINTS.BENCHMARKS}`,
  }).then((response) => response.data.benchmarks);
}